<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
  <c-modal-header>
      <h4 class="modal-title">{{ "User" }}</h4>
      <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal(false)" title="Close"></button>
  </c-modal-header>
  <c-modal-body>
    <c-row>
      <form cForm class="animate" (ngSubmit)="saveUser()" [formGroup]="userDetailForm">
        <c-row>
          <c-col>
            <c-card class="mb-4">
              <c-card-header>Details</c-card-header>
              <c-card-body>
                <!-- Branch -->
                <c-row>
                  <c-col [md]="3">
                    <label cLabel for="branch">{{ "Branch" }}</label>
                  </c-col>
                  <c-col [md]="8">
                    <select cFormControl formControlName="branch" aria-label="Please select a branch" cSelect>
                      <option *ngFor="let branch of branchesList" [ngValue]="branch">{{branch.name}}</option>
                    </select>
                  </c-col>
                </c-row>

                <!-- Username -->
                <c-row>
                  <c-col [md]="3">
                    <label cLabel for="username">{{ "Username" }}</label>
                  </c-col>
                  <c-col [md]="8">
                    <input cFormControl formControlName="username" name="username" type="text" class="form-control" id="username" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!userDetailForm.controls['username'].valid && !userDetailForm.controls['username'].untouched">
                      {{ "Username is required" }}
                    </div>
                  </c-col>
                </c-row>

                <!-- First Name -->
                <c-row>
                  <c-col [md]="3">
                    <label cLabel for="firstName">{{ "First Name"}}</label>
                  </c-col>
                  <c-col [md]="8">
                    <input cFormControl formControlName="firstName" name="firstName" type="text" class="form-control" id="firstName" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!userDetailForm.controls['firstName'].valid && !userDetailForm.controls['firstName'].untouched">
                      {{ "First name is required" }}
                    </div>
                  </c-col>
                </c-row>

                <!-- Last Name -->
                <c-row>
                  <c-col [md]="3">
                    <label cLabel for="lastName">{{ "Last Name" }}</label>
                  </c-col>
                  <c-col [md]="8">
                    <input cFormControl formControlName="lastName" name="lastName" type="text" class="form-control" id="lastName" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!userDetailForm.controls['lastName'].valid && !userDetailForm.controls['lastName'].untouched">
                      {{ "Last name is required" }}
                    </div>
                  </c-col>
                </c-row>

                <!-- Email -->
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="email">{{ "Email" }}</label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="email" name="email" type="email" class="form-control" id="email" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="userDetailForm.controls['email'].hasError('required') && !userDetailForm.controls['email'].untouched">
                        {{ "Email is required." }}
                    </div>
                  </c-col>
                </c-row>

                <!-- <c-row>
                    <c-col [md]='3'></c-col>
                    <c-col [md]='8'>
                      <button type="submit" [disabled]="!userDetailForm.valid" class="btn btn-primary primary w-100">
                          <i class="fa fa-circle-o-notch fa-spin" [hidden]="!isSavingUser"></i>
                          <c-spinner [hidden]="!isSavingUser"></c-spinner>{{ "Submit" }}
                      </button>
                    </c-col>
                </c-row> -->
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>

        <c-row>
          <c-col>
            <c-card class="mb-4">
              <c-card-header>Permissions</c-card-header>
              <c-card-body>
                <!-- Dashboard -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Dashboard</h5>
                  </c-col>
                </c-row>
                <!-- View Dashboard -->
                <c-row>
                  <c-col [md]='12'>
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isViewDashboard" id="isViewDashboard" type="checkbox" />
                      <label cFormCheckLabel for="isViewDashboard">View Dashboard</label>
                    </c-form-check>
                  </c-col>
                </c-row>

                <c-row [xs]="1" [xl]="2">
                  <!-- Owner & Pet column -->
                  <c-col>
                    <!-- Owner & Pet -->
                    <c-row>
                      <c-col>
                        <h6>Owner & Pet</h6>
                      </c-col>
                    </c-row>
                    
                    <!-- Number of Owners -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewNumberOfOwners" id="isViewNumberOfOwners" type="checkbox" [checked]="isSelected('view_dashboard_number_of_owners')"/>
                          <label cFormCheckLabel for="isViewNumberOfOwners">View number of owners</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Number of Pets -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewNumberOfPets" id="isViewNumberOfPets" type="checkbox" />
                          <label cFormCheckLabel for="isViewNumberOfPets">View number of pets</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Number of Check-ins -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewNumberOfCheckIns" id="isViewNumberOfCheckIns" type="checkbox" />
                          <label cFormCheckLabel for="isViewNumberOfCheckIns">View number of check-ins</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Number of Check-in Pets -->
                    <!-- <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewNumberOfCheckInPets" id="isViewNumberOfCheckInPets" type="checkbox" />
                          <label cFormCheckLabel for="isViewNumberOfCheckInPets">View number of check-in pets</label>
                        </c-form-check>
                      </c-col>
                    </c-row> -->

                    <!-- Number of Registrations -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewNumberOfRegistrations" id="isViewNumberOfRegistrations" type="checkbox" />
                          <label cFormCheckLabel for="isViewNumberOfRegistrations">View number of registrations</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Revenue & Expense column -->
                  <c-col>
                    <!-- Revenue & Expense -->
                    <c-row>
                      <c-col>
                        <h6>Revenue & Expense</h6>
                      </c-col>
                    </c-row>

                    <!-- Total Revenue -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewTotalRevenue" id="isViewTotalRevenue" type="checkbox" />
                          <label cFormCheckLabel for="isViewTotalRevenue">View total revenue</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Total Expense -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewTotalExpense" id="isViewTotalExpense" type="checkbox" />
                          <label cFormCheckLabel for="isViewTotalExpense">View total expense</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Total Income -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewTotalIncome" id="isViewTotalIncome" type="checkbox" />
                          <label cFormCheckLabel for="isViewTotalIncome">View total income</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Monthly Revenue -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewMonthlyRevenue" id="isViewMonthlyRevenue" type="checkbox" />
                          <label cFormCheckLabel for="isViewMonthlyRevenue">View monthly revenue</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Monthly Expense -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewMonthlyExpense" id="isViewMonthlyExpense" type="checkbox" />
                          <label cFormCheckLabel for="isViewMonthlyExpense">View monthly expense</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Total Income -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewMonthlyIncome" id="isViewMonthlyIncome" type="checkbox" />
                          <label cFormCheckLabel for="isViewMonthlyIncome">View monthly income</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Current Year Monthly Revenue -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCurrentYearMonthlyRevenue" id="isViewCurrentYearMonthlyRevenue" type="checkbox" />
                          <label cFormCheckLabel for="isViewCurrentYearMonthlyRevenue">View current year monthly revenue</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Current Year Monthly Expense -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCurrentYearMonthlyExpense" id="isViewCurrentYearMonthlyExpense" type="checkbox" />
                          <label cFormCheckLabel for="isViewCurrentYearMonthlyExpense">View current year  monthly expense</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Current Year Total Income -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCurrentYearMonthlyIncome" id="isViewCurrentYearMonthlyIncome" type="checkbox" />
                          <label cFormCheckLabel for="isViewCurrentYearMonthlyIncome">View current year monthly income</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- Pet -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Pet</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Pets List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewPetList" id="isViewPetList" type="checkbox" />
                          <label cFormCheckLabel for="isViewPetList">View pets list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Pet -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddPet" id="isAddPet" type="checkbox" />
                          <label cFormCheckLabel for="isAddPet">Add pet</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View Pet Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewPetDetail" id="isViewPetDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewPetDetail">View pet details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update Pet Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdatePetDetail" id="isUpdatePetDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdatePetDetail">Update pet details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>
                
                <!-- Owner -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Owner</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Owners List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewOwnerList" id="isViewOwnerList" type="checkbox" />
                          <label cFormCheckLabel for="isViewOwnerList">View owners list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Owner -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddOwner" id="isAddOwner" type="checkbox" />
                          <label cFormCheckLabel for="isAddOwner">Add owner</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View Owner Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewOwnerDetail" id="isViewOwnerDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewOwnerDetail">View owner details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update Owner Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateOwnerDetail" id="isUpdateOwnerDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateOwnerDetail">Update owner details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- Pick Up -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Pick Up</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Pick ups List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewPickUpList" id="isViewPickUpList" type="checkbox" />
                          <label cFormCheckLabel for="isViewPickUpList">View pick ups list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Pick up -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddPickUp" id="isAddPickUp" type="checkbox" />
                          <label cFormCheckLabel for="isAddPickUp">Add pick up</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View Pick up Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewPickUpDetail" id="isViewPickUpDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewPickUpDetail">View pick up details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update Pick up Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdatePickUpDetail" id="isUpdatePickUpDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdatePickUpDetail">Update pick up details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- Check-In -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Check-In</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View CheckIns List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCheckInList" id="isViewCheckInList" type="checkbox" />
                          <label cFormCheckLabel for="isViewCheckInList">View check-ins list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Owner -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddCheckIn" id="isAddCheckIn" type="checkbox" />
                          <label cFormCheckLabel for="isAddCheckIn">Add check-in</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View CheckIn Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCheckInDetail" id="isViewCheckInDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewCheckInDetail">View check-in details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update CheckIn Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateCheckInDetail" id="isUpdateCheckInDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateCheckInDetail">Update check-in details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>
                
                <!-- Check-Out -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Check-Out</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Check-outs List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCheckOutList" id="isViewCheckOutList" type="checkbox" />
                          <label cFormCheckLabel for="isViewCheckOutList">View check-outs list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Check-out -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddCheckOut" id="isAddCheckOut" type="checkbox" />
                          <label cFormCheckLabel for="isAddCheckOut">Add check-out</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View Check-out Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewCheckOutDetail" id="isViewCheckOutDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewCheckOutDetail">View check-out details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update Check-out Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateCheckOutDetail" id="isUpdateCheckOutDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateCheckOutDetail">Update check-out details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- Invoice -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Invoice</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Invoices List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewInvoiceList" id="isViewInvoiceList" type="checkbox" />
                          <label cFormCheckLabel for="isViewInvoiceList">View invoices list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Invoice -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddInvoice" id="isAddInvoice" type="checkbox" />
                          <label cFormCheckLabel for="isAddInvoice">Add invoice</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View Invoice Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewInvoiceDetail" id="isViewInvoiceDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewInvoiceDetail">View invoice details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update Invoice Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateInvoiceDetail" id="isUpdateInvoiceDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateInvoiceDetail">Update invoice details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- Expense -->
                <c-row>
                  <c-col [md]="3">
                    <h5>Expense</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Expenses List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewExpenseList" id="isViewExpenseList" type="checkbox" />
                          <label cFormCheckLabel for="isViewExpenseList">View expenses list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add Expense -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddExpense" id="isAddExpense" type="checkbox" />
                          <label cFormCheckLabel for="isAddExpense">Add expense</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View Expense Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewExpenseDetail" id="isViewExpenseDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewExpenseDetail">View expense details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update Expense Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateExpenseDetail" id="isUpdateExpenseDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateExpenseDetail">Update expense details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- User -->
                <c-row>
                  <c-col [md]="3">
                    <h5>User</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View Users List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewUserList" id="isViewUserList" type="checkbox" />
                          <label cFormCheckLabel for="isViewUserList">View users list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add User -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddUser" id="isAddUser" type="checkbox" />
                          <label cFormCheckLabel for="isAddUser">Add user</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update User Permission -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateUserPermission" id="isUpdateUserPermission" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateUserPermission">Update user permissions</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View User Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewUserDetail" id="isViewUserDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewUserDetail">View user details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update User Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateUserDetail" id="isUpdateUserDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateUserDetail">Update user details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- QR Code -->
                <c-row>
                  <c-col [md]="3">
                    <h5>QR Code</h5>
                  </c-col>
                </c-row>
                <c-row [xs]="1" [xl]="2">
                  <!-- Left column -->
                  <c-col>
                    <!-- View QR Codes List -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewQRCodeList" id="isViewQRCodeList" type="checkbox" />
                          <label cFormCheckLabel for="isViewQRCodeList">View QR codes list</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Add QRCode -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isAddQRCode" id="isAddQRCode" type="checkbox" />
                          <label cFormCheckLabel for="isAddQRCode">Add QR code</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                  <!-- Right column -->
                  <c-col>
                    <!-- View QRCode Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isViewQRCodeDetail" id="isViewQRCodeDetail" type="checkbox" />
                          <label cFormCheckLabel for="isViewQRCodeDetail">View QR code details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>

                    <!-- Update QRCode Details -->
                    <c-row>
                      <c-col [md]='12'>
                        <c-form-check [inline]="true">
                          <input cFormCheckInput  formControlName="isUpdateQRCodeDetail" id="isUpdateQRCodeDetail" type="checkbox" />
                          <label cFormCheckLabel for="isUpdateQRCodeDetail">Update QR code details</label>
                        </c-form-check>
                      </c-col>
                    </c-row>
                  </c-col>
                </c-row>

                <!-- <div formGroupName="permissions">
                  <c-row *ngFor="let permission of permissions">
                    <c-col [md]='12'>
                      <c-form-check [inline]="true">
                        <input cFormCheckInput  [formControlName]="permission.codename" type="checkbox"/>
                        <label cFormCheckLabel [for]="permission.codename">{{permission.codename}}</label>
                      </c-form-check>
                    </c-col>
                  </c-row>
                </div> -->
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>
      </form>
    </c-row>
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="secondary" (click)="closeModal(false)">Close</button>
    <button *ngIf="hasAddPermission || hasEditPermission || hasEditUserPermissionPermission" cButton color="primary" (click)="saveUser()">Submit</button>
  </c-modal-footer>
</c-modal>
